/*
 * VULCAN
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/groupsMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Groups. */
var Groups = /** @class */ (function () {
    /**
     * Create a Groups.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Groups(client) {
        this.client = client;
    }
    Groups.prototype.getGroup = function (objectId, options, callback) {
        return this.client.sendOperationRequest({
            objectId: objectId,
            options: options
        }, getGroupOperationSpec, callback);
    };
    return Groups;
}());
export { Groups };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getGroupOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/groups/{objectId}",
    urlParameters: [
        Parameters.objectId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GroupResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=groups.js.map